import React, { useState, useEffect } from 'react'
import Input from 'components/Input'
import PhoneNumberInput from 'components/PhoneNumberInput'
import { withTranslation } from 'react-i18next'
import { filterValues } from 'Helper'
import useSWR from 'swr'
// import usePos from 'hooks/usePos'
import { useFormContext } from 'react-hook-form'


export default withTranslation()(function AddUser({ t, isFromEdit, initialValues }) {

  const { reset } = useFormContext()
  const { data: Roles } = useSWR('user-mgmt/roles')
  // const { data: Branches } = useSWR('merchants/branches')


  // const { pos: Pos } = usePos(watch().branch_id)

  const [roles, setRoles] = useState()
  // const [branches, setBranches] = useState()
  // const [pos, setPos] = useState()

  useEffect(() => { if (Roles?.data) setRoles(Roles.data) }, [Roles]);
  // useEffect(() => { if (Pos?.data) setPos(Pos.data) }, [Pos]);
  // useEffect(() => { if (Branches?.data) setBranches(Branches.data.data) }, [Branches]);

  useEffect(() => { reset({ ...initialValues }) }, [initialValues, reset])
  console.log({ value: initialValues?.roles[0].id, label: initialValues?.roles[0]?.display_name })

  const fields = [
    [
      {
        name: 'first_name',
        label: t('settings.user_management.form.firstname.label'),
        placeholder: t('settings.user_management.form.firstname.placeholder'),
        value: isFromEdit ? initialValues.first_name : ''
      },
      {
        name: 'last_name',
        label: t('settings.user_management.form.lastname.label'),
        placeholder: t('settings.user_management.form.lastname.placeholder'),
        value: isFromEdit ? initialValues.last_name : ''
      }
    ],
    {
      name: 'email',
      label: t('settings.user_management.form.email.label'),
      placeholder: t('settings.user_management.form.email.placeholder'),
      value: isFromEdit ? initialValues.email : ''
    },
    {
      name: 'phone',
      label: t('settings.user_management.form.phone.label'),
      placeholder: t('settings.user_management.form.phone.placeholder'),
      value: isFromEdit ? initialValues.phone : ''
    },
    {
      name: 'role_id',
      label: 'Role',
      placeholder: 'Select role ',
      options: roles ? filterValues({ options: roles, param: { value: 'id', label: 'display_name' } }) : [],
      defaultValue: isFromEdit ? { value: initialValues?.roles[0].id, label: initialValues?.roles[0]?.display_name } : ''
      // options: [
      //   {
      //     value: '',
      //     label: 'Select role'
      //   }
      // ]
    },
    // [
    //   {
    //     name: 'branch_id',
    //     label: 'Branch',
    //     placeholder: 'Select branch',
    //     options: branches ? filterValues({ options: branches, param: { value: 'id', label: 'name' } }) : []
    //   },
    //   {
    //     name: 'pos_id',
    //     label: 'POS',
    //     placeholder: 'Select pos',
    //     options: pos ? filterValues({ options: pos, param: { value: 'id', label: 'name' } }) : [],
    //     disabled: !watch().branch_id && !watch().branch_id
    //   }
    // ]
  ]

  // console.log('Roles available', roles)

  return (
    <>
      {
        fields.map((field, index) => {
          return (
            <div className="grid grid-cols-2 gap-2" key={index.toString()}>
              {
                field?.length ? (
                  <>
                    {
                      field.map((singlefield, index) => {
                        return (
                          <div className="w-full mb-1" key={singlefield.name}>
                            {!singlefield?.options ? (
                              <> <Input
                                name={singlefield.name}
                                label={singlefield.label}
                                placeholder={singlefield.placeholder}
                                variant="filled"
                                defaultValue={singlefield.value}
                              /></>
                            ) : (
                              < Input
                                name={singlefield.name}
                                label={singlefield.label}
                                placeholder={singlefield.placeholder}
                                options={singlefield?.options}
                                variant="filled"
                                disabled={singlefield?.disabled}
                                defaultValue={singlefield?.defaultValue}
                              />
                            )}
                          </div>
                        )
                      })
                    }
                  </>
                ) : (
                  <div className="w-full col-span-2 mb-4">
                    {
                      field.name === 'phone' ? (
                        <PhoneNumberInput
                          name={field.name}
                          label={field.label}
                          className="w-full border p-4 rounded-lg bg-default"
                          passedValue={field.value}
                        />
                      ) : (
                        <Input
                          name={field.name}
                          label={field.label}
                          placeholder={field.placeholder}
                          options={field?.options ?? null}
                          value={field.value}
                          variant="filled"
                        />
                      )
                    }
                  </div>
                )
              }
            </div>
          )
        })
      }
    </>
  )
})
